import React, { Component } from 'react'

export default class extends Component {
  static defaultProps = {
    bottom: 200
  }

  render() {
    const { visible, imagePath, goTo, close, bottom } = this.props

    return visible ? (
      <div style={{ position: 'fixed', bottom, right: 20 }}>
        <div className="text-right">
          <img
            style={{ verticalAlign: 'middle', cursor: 'pointer' }}
            src="//qnm.hunliji.com/o_1ckr8cevp13hh41h6l5150b99h7.png"
            onClick={close}
          />
        </div>

        <img
          style={{
            marginTop: 20,
            maxWidth: 200,
            maxHeight: 360,
            cursor: 'pointer'
          }}
          src={imagePath}
          onClick={goTo}
        />
      </div>
    ) : null
  }
}
